import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';

export type CardHeaderProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Makes the background white.
   */
  isWhite?: boolean;
};

export const CardHeader = ({ children, isWhite = false }: CardHeaderProps) => (
  <div className={joinClassNames(styles.cardHeader, isWhite && styles.bgWhite)}>{children}</div>
);
